import { format, parseISO } from 'date-fns'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { DATE_SHORT_FORMAT } from '../../../constants/date'
import i18n from '../../../i18n'
import { getListingUnitLabel } from '../../RentalPortalListing'
import {
  getMockArchivedViewings,
  performMockViewingsMassAction,
  VIEWING_MASS_ACTION,
} from '../../RentalPortalViewing'

import { RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE } from './RentalPortalArchive.constants'
import { getIsRentalPortalArchiveObjectTypeKnown } from './RentalPortalArchive.utils'

function toMockArchiveItemFromViewing(viewing) {
  return {
    archived_at: viewing.archived_at,
    id: `${RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE.viewing}-${viewing.id}`,
    object_id: viewing.id,
    object_name: `${getListingUnitLabel({ listing: viewing, t: i18n.t })} · ${format(
      parseISO(viewing.start),
      DATE_SHORT_FORMAT
    )}`,
    object_type: RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE.viewing,
    permissions: { can_restore: viewing.permissions.can_restore },
    responsible_user: null,
  }
}

export function getMockArchivedViewingItems() {
  return getIsRentalPortalArchiveObjectTypeKnown(
    RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE.viewing
  )
    ? getMockArchivedViewings().map(toMockArchiveItemFromViewing)
    : EMPTY_LIST
}

export function performMockArchivedViewingsRestore(ids) {
  return performMockViewingsMassAction({
    action: VIEWING_MASS_ACTION.restore,
    all: false,
    filters: { archived: true, exclude_id: EMPTY_LIST, id: ids },
    payload: EMPTY_OBJECT,
  })
}
